<template>
  <div v-if="$route.name !='scorecard' && $route.name !='summary' && $route.name !='lanes'">
    <div class="footer">
      <div class="footer-mobile">
        <ul>
          <li>v1.1 BETA 06/25/2026b</li>
          <li>&copy; 2026 <a href="http://wildaxe.com/lumberjack/" target="_blank">Wild Axe Productions</a></li>
          <li>Built by <a href="https://www.topsailsoftware.ca/" target="_blanl">Topsail Software Inc</a></li>
          <li><a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms</a></li>
          <li><a href="mailto: contact@axes2.ca">contact@axes2.ca</a></li>
        </ul>
      </div>
      <div class="footer-desktop">
        <p style="font-size: 0.8em">
          v1.1 BETA 06/25/2026b |
          &copy; 2026 <a href="http://wildaxe.com/lumberjack/" target="_blank">Wild Axe Productions</a> | 
          Built by <a href="https://www.topsailsoftware.ca/" target="_blank">Topsail Software Inc</a> |
          <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms</a> | <a href="mailto: contact@axes2.ca">contact@axes2.ca</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    methods: {
    },
    computed: {
    },
    mounted(){
    }
  }
</script>

<style lang="scss" scoped>
.footer {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  background-color: #1a1a1a;
  color: #b5b5b5;
  width: 100%;
  padding: 20px 0;
  font-size: 0.9em;
  text-align: center;
  border-top: 1px solid #333;
}

.footer a {
  color: #48c774;
  text-decoration: none;
  transition: color 0.2s;
}

.footer a:hover {
  color: #fff;
  text-decoration: underline;
}

.footer-mobile {
  display: inline;
}
.footer-desktop {
  display: none;
}

@media screen and (min-width: 600px) {
  .footer-desktop {
    display: inline;
  }
  .footer-mobile {
    display: none;
  }
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  margin-bottom: 5px;
}
</style>